__turbopack_context__.v({
  "mobileContent": "YGa8nG_mobileContent",
  "popoverButton": "YGa8nG_popoverButton",
  "popoverContent": "YGa8nG_popoverContent",
  "popoverDescription": "YGa8nG_popoverDescription",
  "popoverLink": "YGa8nG_popoverLink",
  "popoverTitle": "YGa8nG_popoverTitle",
  "popoverTop": "YGa8nG_popoverTop",
  "tabletAndWebContent": "YGa8nG_tabletAndWebContent",
  "trigger": "YGa8nG_trigger",
});
